<footer id="footer" class="footer">
  <div class="copyright">© {{ anio }} <strong>A2 Hacienda</strong>. Todos los derechos reservados.</div>
</footer>
